import React from 'react';
import {
    useSceneStore,
} from '../store'
import { navigate } from "hookrouter";

export const OVERLAY_RETURN_PATH_KEY = 'overlayReturnPath';

export function isOverlayPath(routePath) {
  return routePath.startsWith('/category/') || routePath === '/lesson-plans';
}

const CloseButton = ({toggleOverlay, goBack = true, ...props}) => {

    const { setCursorActive, setFeatured, setModalState, setDomRef, setEvents,setMode,setScene, setScrollPos, setBookState, setTopic, setHomeMessage, setBkgdColor, setCharacter, setTalk, setShuffled, setShowBug, setContentLayout, setBookIndex, setBookOtherIndex,setLoaded } = useSceneStore(state => state.actions)

    function setCursor(msg, boo){
        setCursorActive(boo)
        setTopic(msg)
    }

    function handleGoBack() {
      const returnPath = window.sessionStorage.getItem(OVERLAY_RETURN_PATH_KEY);
      window.sessionStorage.removeItem(OVERLAY_RETURN_PATH_KEY);
      navigate(returnPath || '/');
    }

    return (
        <button 
        onMouseEnter={() => setCursor('', false)} 
        onMouseLeave={() => setCursor('', true)} 
        onClick={() => {
          toggleOverlay();
          if (goBack) handleGoBack();
        }} 
        className="close-btn clickable"
        >
          X
        </button>
    )
}

export default CloseButton;